import { memoriserFbclid } from "./meta";
import { memoriserCampagne } from "./campagneCourante";
import { track } from "./track";

/**
 * Attribution des arrivées de campagne.
 *
 * L'acquisition payante est rendue possible par le prix dirigeant — c'est
 * l'arbitrage du 18/08 — mais rien ne captait les paramètres `utm` d'une
 * annonce : la première campagne aurait dépensé sans qu'aucun chiffre ne dise
 * ce qu'elle a ramené. L'attribution passe par le `sid`, comme tout le reste :
 * l'évènement d'arrivée porte la source et la campagne, et le parcours complet
 * de la session se reconstitue sans cookie ni identifiant nominatif.
 */

/** Longueur maximale d'un libellé de campagne : au-delà, c'est du bruit. */
const LIBELLE_MAX = 60;

function propre(valeur: string | null): string | null {
  if (valeur === null) return null;
  const nettoye = valeur.trim().slice(0, LIBELLE_MAX);
  return nettoye === "" ? null : nettoye;
}

export interface CampagneArrivee {
  source: string;
  campagne: string | null;
  support: string | null;
}

/** Les paramètres de campagne lus dans des paramètres d'adresse. Pure, testée. */
export function campagneDepuisParams(params: URLSearchParams): CampagneArrivee | null {
  const source = propre(params.get("utm_source"));
  if (source === null) return null;
  return {
    source,
    campagne: propre(params.get("utm_campaign")),
    support: propre(params.get("utm_medium")),
  };
}

/** Les paramètres de campagne lus dans l'adresse d'arrivée, s'il y en a. */
export function campagneDepuisUrl(): CampagneArrivee | null {
  return campagneDepuisParams(new URLSearchParams(window.location.search));
}

let signalee = false;

/**
 * Signale l'arrivée de campagne, une fois par chargement. Appelée depuis les
 * deux pages d'atterrissage possibles — l'accueil et `/dirigeant` — parce
 * qu'une annonce dirigeant enverra sur `/dirigeant`, pas sur `/`.
 */
export function signalerCampagne(): void {
  // L'identifiant de clic Meta arrive souvent sans paramètre utm : il est
  // retenu à part, et ne sert qu'avec le consentement de la personne (T43).
  memoriserFbclid();
  if (signalee) return;
  const campagne = campagneDepuisUrl();
  if (campagne === null) return;
  signalee = true;
  // Retenue pour la session : c'est elle qui permet de lire, dans /pilotage,
  // combien de diagnostics et de ventes chaque annonce a réellement produits.
  memoriserCampagne(campagne.campagne ?? campagne.source);
  // Le libellé tel qu'écrit dans le lien reste lisible dans l'évènement, sous
  // `libelle` : `campagne` est réservé à l'identifiant que `track` joint.
  track("campagne_arrivee", {
    source: campagne.source,
    libelle: campagne.campagne,
    support: campagne.support,
    page: window.location.pathname,
  });
}
